import React, { useState, useEffect, useRef } from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../../components/mensajes";
import {
  seleccionarCampo,
  formatMoneda,
  validaSoloNumero,
  validaMonto,
  formatoMonto,
  cmbCedula,
} from "../../util/varios";
import moment from "moment";
import CatalogoCliente from "../../catalogos/catalogoCliente";
import CatalogoNotaEntrega from "../../catalogos/catalogoNotaEntrega";

const TablaNotaCredito = () => {
  const op = require("../../../public/modulos/datos");
  const token = sessionStorage.getItem("jwtToken");
  const fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
  const idVendedor = JSON.parse(sessionStorage.getItem("idagente"));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
  const accbtnndebito = JSON.parse(sessionStorage.getItem("accbtnndebitoc"));

  const txtIdNotaEntrega = useRef();
  const txtFecha = useRef();
  const txtConcepto = useRef();
  const txtMontoTotal = useRef();
  const btnIncluir = useRef();
  const btnEditar = useRef();
  const btnEliminar = useRef();
  const btnConsultar = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnProducto = useRef();
  const cmbRif = useRef();
  const txtRif = useRef();
  const txtSubTotal = useRef();
  const txtDescuento = useRef();
  const txtTotIva = useRef();
  const txtTotal = useRef();
  const txtTotalDivisa = useRef();
  const txtIdPedido = useRef();
  const cmbMoneda = useRef();
  const txtDias = useRef();
  const txtFechaVencimiento = useRef();

  const [body, setBody] = useState(null);
  const [operacion, setOperacion] = useState(0);
  const [habilitado, setHabilitado] = useState(false);
  const [habilitarCat, setHabilitarCat] = useState(true);
  const [habilitadoBot, setHabilitadoBot] = useState(true);
  const [habilitadoCli, setHabilitadoCli] = useState(false);
  const [numNota, setNumNota] = useState("");
  const [cedRif, setCedRif] = useState("");
  const [nomVendedor, setNomVendedor] = useState("");
  const [idCliente, setIdCliente] = useState("");
  const [nomCliente, setNomCliente] = useState("");
  const [dirCliente, setDirCliente] = useState("");
  const [visible, setVisible] = useState(0);
  const [desde, setDesde] = useState(0);
  const [habilitarMoneda, setHabilitarMoneda] = useState(false);
  const [combomoneda, setComboMoneda] = useState([]);
  const [tituloHeader, setTituloHeader] = useState(
    "Gestionar Nota de Credito."
  );
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [moneda, setMoneda] = useState({
    idmoneda: "1",
    descripcion: "BOLIVARES",
    simbolo: "Bs",
    predeterminada: true,
    subpredeterminada: false,
    valormoneda: 1.0,
  });
  const [monedaSub, setMonedaSub] = useState({
    idmoneda: "4",
    descripcion: "DOLAR",
    simbolo: "$",
    predeterminada: false,
    subpredeterminada: true,
    valormoneda: 1.0,
  });

  const [catalogoCliente, setCatalogoCliente] = useState(false);
  const [catalogoNota, setCatalogoNota] = useState(false);
  const [activate, setActivate] = useState(false);
  const [visibleBtn, setVisibleBtn] = useState("visible");

  const handleInputNumeroChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (event.target.name === "idnotaentre") {
          seleccionarRegistro();
        }
      }
    }
  };

  const validarCliente = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (cmbRif.current.value !== "" && event.target.value !== "") {
        let rif = cmbRif.current.value + event.target.value;
        seleccionarCliente(rif, event.which);
      }
    }
  };

  const blanquear = () => {
    setTituloHeader("Gestionar Notas de Debito.");
    setBody();
    setActivate(false);
    setOperacion(0);
    setHabilitado(false);
    setHabilitarMoneda(false);
    setHabilitadoCli(false);
    setHabilitadoBot(true);
    setHabilitarCat(true);
    setVisible(0);
    cmbMoneda.current.selectedIndex = -1;
    setVisibleBtn("visible");
    setMoneda({
      idmoneda: "1",
      descripcion: "BOLIVARES",
      simbolo: "Bs",
      predeterminada: false,
      valormoneda: 1.0,
    });
    txtIdNotaEntrega.current.value = "";
    txtFechaVencimiento.current.value = "";
    txtIdNotaEntrega.current.setAttribute("disabled", true);
    cmbRif.current.selectedIndex = -1;
    txtRif.current.value = "";
    setNumNota("");
    setNomCliente("");
    setDirCliente("");
    setNomVendedor("");
    setCedRif("");
    txtFecha.current.value = "";
    txtMontoTotal.current.value = "0,00";
    txtTotalDivisa.current.value = "0,00";
    txtConcepto.current.value = "";
  };

  const procesarRegistro = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/inventario/actualizarnotaentrega/${operacion}`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "registro " + response.data.idnotaent + " creado correctamente",
              icono: "exito",
            });
            window.open(
              op.reportes +
                "/ventas?afiliado=" +
                afiliado +
                "&reporte=ReportNotaCredito&idnota=" +
                response.data.idnotaent,
              "Planilla",
              "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
            );
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "registro " +
                response.data.idnotaent +
                " modificado correctamente",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "registro " +
                response.data.idnotaent +
                " eliminado correctamente",
              icono: "exito",
            });
          }
          blanquear();
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = error.response.data.message;

        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const validarCantidad = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.length
        );
      }
      let precio = parseFloat(
        event.target.value.replace(/\./g, "").replace(",", ".")
      );
      precio = precio * moneda.valormoneda;
      txtMontoTotal.current.value = formatMoneda(
        precio.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const onCambioMoneda = (values) => {
    let totaldivisa = 0.0;
    let precio = 0.0;

    totaldivisa = parseFloat(
      txtTotalDivisa.current.value.replace(/\./g, "").replace(",", ".")
    );
    precio = totaldivisa * parseFloat(values.valormoneda);

    txtMontoTotal.current.value = formatMoneda(
      precio.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 1) {
      setDesde(0);
    } else if (desde === 2) {
      setDesde(0);
      procesarRegistro();
    }
  };

  const handleCloseMensaje = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 3) {
      setDesde(0);
      window.location.href = "/inicio";
    } else if (desde === 4) {
      setDesde(0);
      txtIdNotaEntrega.current.focus();
    }
  };

  const onChange = (e) => {
    if (e.target.name === "tipo") {
      e.target.value = e.target.value.toUpperCase();
      txtIdPedido.current.value = "";
      txtRif.current.value = "";
      cmbRif.current.selectedIndex = -1;
      cmbMoneda.current.selectedIndex = 0;
      setIdCliente();
      setNomCliente("");
      setDirCliente("");
      txtSubTotal.current.value = "";
      txtTotIva.current.value = "";
      txtTotal.current.value = "";
      txtDescuento.current.value = "";

      if (e.target.value === "1") {
        setHabilitadoCli(true);

        setHabilitarMoneda(true);
      } else {
        setHabilitadoCli(false);

        setHabilitarMoneda(false);
      }
    } else if (e.target.name === "cedula") {
      setIdCliente();
      setNomCliente("");
      setDirCliente("");
    } else if (e.target.name === "idpedi") {
      setNomCliente("");
      setDirCliente("");
      txtFecha.current.value = "";
      cmbMoneda.current.selectedIndex = 0;
    }
  };

  const seleccionarCliente = (rif, tecla) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "rif";
    let nomid2 = "cliente";
    let id = rif;
    let endpoint = "";

    endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            cmbRif.current.value = response.data.rif.trim().substring(0, 1);
            txtRif.current.value = response.data.rif.trim().substring(1, 10);
            setIdCliente(response.data.idagente);
            setNomCliente(response.data.nombre);
            setDirCliente(response.data.direccion.trim());
            if (tecla === 13) {
              txtFecha.current.focus();
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe un cliente con este codigo",
              icono: "informacion",
            });
            txtRif.current.value = "";
            cmbRif.current.selectedIndex = -1;
            if (tecla === 13) {
              txtRif.current.focus();
            }
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarVendedor = (idv) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "idagente";
    let nomid2 = "vendedor";
    let id = idv === null ? "0" : idv;
    let endpoint = "";

    endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            setCedRif(response.data.rif);
            setNomVendedor(response.data.nombre);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El usuario no tiene un vendedor asociado",
              icono: "informacion",
            });
            blanquear();
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarRegistro = () => {
    let campos =
      "n.*, n.descripcion as concepto, m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor";
    let nomtab =
      "notaentrega as n inner join moneda m  on n.idmoneda=m.idmoneda left join monedadetalle as md on m.idmoneda=md.idmoneda";
    let nomid =
      "md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda) and idnotaentrega ";

    let id = txtIdNotaEntrega.current.value;
    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=tipo&id2=NC`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            if (
              response.data.status === 1 &&
              (operacion === 2 || operacion === 3)
            ) {
              setDesde(4);
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "La Nota de Entrega ya tiene factura asociada.",
                icono: "informacion",
              });
              setActivate(false);
              txtIdNotaEntrega.current.value = "";
              txtIdNotaEntrega.current.focus();
              return;
            }
            txtIdNotaEntrega.current.setAttribute("disabled", true);
            setHabilitarCat(true);
            setVisible(0);
            if (operacion === 2) {
              setHabilitadoCli(true);

              setHabilitarMoneda(true);
            } else {
              setHabilitadoCli(false);
            }

            txtFecha.current.value = moment(response.data.fecha).format(
              "YYYY-MM-DD"
            );
            txtFechaVencimiento.current.value = moment(
              response.data.fechavencimiento
            ).format("YYYY-MM-DD");
            setNumNota(response.data.numnotaentrega);
            cmbRif.current.value = response.data.cedularif
              .trim()
              .substring(0, 1);
            txtRif.current.value = response.data.cedularif
              .trim()
              .substring(1, 10);
            setMoneda({
              idmoneda: response.data.idmoneda,
              descripcion: response.data.descripcion,
              simbolo: response.data.simbolo,
              predeterminada: response.data.predeterminada,
              subpredeterminada: response.data.subpredeterminada,
              valormoneda: response.data.valor,
            });
            cmbMoneda.current.value = response.data.idmoneda;
            txtConcepto.current.value = response.data.concepto;
            txtTotalDivisa.current.value = formatMoneda(
              response.data.totalmonto
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );
            let tot = response.data.totalmonto * response.data.valor;
            txtMontoTotal.current.value = formatMoneda(
              tot.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            );
            seleccionarCliente(response.data.cedularif, 46);
            seleccionarVendedor(response.data.idvendedor);
            if (operacion === 2) {
              setHabilitado(true);
              setTimeout(() => txtFecha.current.focus(), 200);
            } else {
              setHabilitado(false);
              setTimeout(() => btnCancela.current.focus(), 200);
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "ID no existe.",
              icono: "informacion",
            });
            txtIdNotaEntrega.current.value = "";
            txtIdNotaEntrega.current.focus();
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const onCatalogoCliente = (values) => {
    setCatalogoCliente(false);
    cmbRif.current.value = values.rif.substring(0, 1);
    txtRif.current.value = values.rif.substring(1);
    setIdCliente(values.idagente);
    setNomCliente(values.nombre);
    setDirCliente(values.direccion);
  };

  const onCatalogoNotaEntrega = (values) => {
    setCatalogoNota(false);
    txtIdNotaEntrega.current.value = values.idnotaentrega;
    seleccionarRegistro();
  };

  const onChangeMoneda = (e) => {
    let i = combomoneda.filter((moneda) => moneda.idmoneda === e.target.value);

    setMoneda(i[0]);
    onCambioMoneda(i[0]);
  };

  const seleccionarMonedas = () => {
    let campos =
      "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
    let nomtab =
      "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
    let orden = "m.idmoneda";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setComboMoneda(response.data);
            setMoneda(response.data[0]);
            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].subpredeterminada) {
                setMonedaSub(response.data[i]);
              }
            }
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const onChangeValidar = () => {
    let sigue = true;

    if (txtIdNotaEntrega.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Código no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtIdNotaEntrega.current.focus();
    } else if (
      cmbRif.current.value === "" ||
      txtRif.current.value.trim() === "" ||
      nomCliente === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Cliente no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtRif.current.focus();
    } else if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Fecha no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (txtFechaVencimiento.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Fecha de Vencimiento no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      txtFechaVencimiento.current.focus();
    } else if (
      txtMontoTotal.current.value === "" ||
      txtMontoTotal.current.value === "0,00"
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Monto no debe estar vacio ni estar en 0,00",
        icono: "informacion",
      });
      sigue = false;
      txtMontoTotal.current.focus();
    } else if (txtConcepto.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Concepto no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtConcepto.current.focus();
    }
    if (sigue) {
      let notae = [];
      notae.push({
        idnotaentrega: txtIdNotaEntrega.current.value,
        numnotaentrega: numNota,
        descripcion: txtConcepto.current.value,
        tipo: "NC",
        cedularif: cmbRif.current.value + txtRif.current.value,
        totalmonto: parseFloat(
          txtTotalDivisa.current.value.replace(/\./g, "").replace(",", ".")
        ),
        totaliva: 0.0,
        totaldescuento: 0.0,
        idpedido: null,
        idcliente: idCliente,
        idvendedor: idVendedor,
        fecha: txtFecha.current.value,
        status: "0",
        idmoneda: monedaSub.idmoneda,
        idoperacioninventario: "",
        credito: true,
        fechavencimiento: txtFechaVencimiento.current.value,
        valormoneda: monedaSub.valormoneda,
      });

      setBody({
        notaentre: notae,
        notaentredet: [],
        idtipopeinv: "2",
        opeinv: [],
        opeinvdet: [],
      });

      setDesde(2);
      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const onBotones = (op) => (e) => {
    e.preventDefault();

    if (op === 1) {
      if (accbtnndebito && accbtnndebito.toString().substring(0, 1) === "1") {
        setTituloHeader("Incluir Nota de Credito.");
        setHabilitadoBot(false);
        setVisibleBtn("hidden");
        setOperacion(op);
        setHabilitado(true);
        setHabilitadoCli(true);
        setHabilitarMoneda(true);
        txtIdNotaEntrega.current.setAttribute("disabled", true);
        seleccionarVendedor(idVendedor);
        setHabilitarCat(true);
        cmbMoneda.current.selectedIndex = 0;
        txtFecha.current.value = moment(fechasistema).format("YYYY-MM-DD");
        txtFechaVencimiento.current.value =
          moment(fechasistema).format("YYYY-MM-DD");
        txtIdNotaEntrega.current.value = "0";
        txtIdNotaEntrega.current.focus();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 2) {
      if (accbtnndebito && accbtnndebito.toString().substring(1, 2) === "1") {
        setHabilitadoBot(false);
        setVisibleBtn("hidden");
        setTituloHeader("Editar Nota de Credito.");
        setOperacion(op);
        txtIdNotaEntrega.current.removeAttribute("disabled");
        setHabilitarCat(false);
        txtIdNotaEntrega.current.focus();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 3) {
      if (accbtnndebito && accbtnndebito.toString().substring(3, 4) === "1") {
        setTituloHeader("Eliminar Nota de Credito.");
        setHabilitadoBot(false);
        setVisibleBtn("hidden");
        setOperacion(op);
        txtIdNotaEntrega.current.removeAttribute("disabled");
        setHabilitarCat(false);
        setHabilitarMoneda(false);
        setHabilitado(false);
        setHabilitadoCli(false);
        txtIdNotaEntrega.current.focus();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 4) {
      if (accbtnndebito && accbtnndebito.toString().substring(2, 3) === "1") {
        setTituloHeader("Consultar Nota de Credito.");
        setHabilitadoBot(false);
        setVisibleBtn("hidden");
        setOperacion(op);
        txtIdNotaEntrega.current.removeAttribute("disabled");
        setHabilitarCat(false);
        setHabilitado(false);
        setHabilitarMoneda(true);
        setHabilitadoCli(false);
        txtIdNotaEntrega.current.focus();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      blanquear();
    }
  };

  const handleInputChange = (event) => {
    event.preventDefault();
    if (event.which === 13) {
      if (event.target.name === "fecha") {
        event.target.value = moment(event.target.value).format("YYYY-MM-DD");
        btnProducto.current.focus();
      } else if (event.target.name === "dias") {
        let dias = txtDias.current.value;
        if (txtDias.current.value > 0) {
          let fechaV = moment(fechasistema)
            .add(dias.toString(), "days")
            .format("YYYY-MM-DD");
          let cambia = event.target.value;
          let dd =
            dias === cambia
              ? cambia
              : txtFechaVencimiento.current.value.substring(8, 10);

          if (event.target.value !== dd) {
            let fechaV = moment(fechasistema)
              .add(dias.toString(), "days")
              .format("YYYY-MM-DD");
          }
        }
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.name === "fecha") {
        event.target.value = moment(event.target.value).format("YYYY-MM-DD");
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  useEffect(() => {
    seleccionarMonedas();
  }, []);

  const imprimirNotaDebito = () => {
    if (accbtnndebito && accbtnndebito.toString().substring(4, 5) === "1") {
      let debt = 0;
      if (txtIdNotaEntrega.current.value !== "") {
        let idnot = txtIdNotaEntrega.current.value;

        var reporte = "ReportNotaCredito";

        window.open(
          op.reportes +
            "/ventas?afiliado=" +
            afiliado +
            "&reporte=" +
            reporte +
            "&idnota=" +
            idnot,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Seleccione la nota de de Credito !",
          icono: "informacion",
        });
        debt = 1;
      }

      if (debt === 1) {
        txtIdNotaEntrega.current.focus();
      }
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "¡No Posee Permiso para Realizar esta Acción!",
        icono: "error",
      });
    }
  };

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div className="row col-md-12 " style={{ margin: 0 }}>
        <div className="row col-md-12 py-2" style={{ margin: 0 }}>
          <div className="col-md-11 mx-auto py-2 card shadow h-100 mt-5">
            <div className="col-md-12 row border-azul mx-auto justify-content-between rounded py-1">
              <div
                className="col-md-12 row mx-auto d-flex justify-content-between mb-1"
                style={{ fontSizeAdjust: "0.6" }}
              >
                <div className="col-md-12 border-azul rounded py-2 row mx-auto mb-3 azulGradiant shadow text-light justify-content-between">
                  <div className="col-md-4">
                    <h3>{tituloHeader}</h3>
                  </div>
                  <div className="col-md-3 d-flex justify-content-end">
                    <a href="/inicio" className="text-light ">
                      <i className="fas fa-times mx-2"></i>
                      <span className="fw-bold">Salir</span>
                    </a>
                  </div>
                </div>

                <div className="colfull col220 mb-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      CODIGO:
                    </label>
                    <input
                      type="text"
                      disabled
                      autoComplete="off"
                      ref={txtIdNotaEntrega}
                      name="idnotaentre"
                      onKeyUp={handleInputNumeroChange}
                      onBlur={handleInputNumeroChange}
                      className="form-control form-control-lg"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                    <button
                      disabled={habilitarCat}
                      type="button"
                      onClick={() => setCatalogoNota(true)}
                      className="btn btn-success"
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                </div>

                <div className="colfull col400 mb-1">
                  <label className="text-left">
                    NOTA DE CREDITO N°:{" "}
                    <span className="col fw-bold text-danger">
                      &nbsp;{numNota}
                    </span>
                  </label>
                </div>
              </div>

              <div
                className="col-md-12 row mx-auto d-flex justify-content-between mb-1"
                style={{ fontSizeAdjust: "0.6" }}
              >
                <div className="colfull col320 mb-3">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      TIPO MONEDA:
                    </label>
                    <select
                      className="form-control form-control-sm fs-6 text-center fw-bold"
                      disabled={!habilitarMoneda}
                      ref={cmbMoneda}
                      onChange={onChangeMoneda}
                    >
                      {combomoneda &&
                        combomoneda.map((item, index) => (
                          <option key={index} value={item.idmoneda}>
                            {" "}
                            {`${item.descripcion} ${
                              item.simbolo
                            } ${formatMoneda(
                              item.valormoneda
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}`}{" "}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
                <div className="col-pd-240 ml-auto">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      FECHA:
                    </label>
                    <input
                      autoComplete="off"
                      type="date"
                      disabled={!habilitado}
                      ref={txtFecha}
                      className="form-control text-uppercase fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      name="fecha"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>
                </div>
                <div className="col-pd-370 ml-auto">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      FECHA DE VENCIMIENTO:
                    </label>
                    <input
                      autoComplete="off"
                      disabled={!habilitado}
                      type="date"
                      ref={txtFechaVencimiento}
                      className="form-control text-uppercase fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      name="fechav"
                    />
                  </div>
                </div>
              </div>

              <div
                className="colfull1070 colfull60p mx-auto mb-1 py-1"
                style={{ fontSizeAdjust: "0.6" }}
              >
                <div className="col-md-12 mx-auto row border-azul rounded py-2">
                  <span className="fw-bold mb-1">Datos del Cliente</span>
                  <div className="input-group input-group-sm mb-2 col-md-5">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      CEDULA/RIF:{" "}
                    </label>
                    <select
                      ref={cmbRif}
                      name="cmbrif"
                      disabled={!habilitadoCli}
                      className="form-select form-select-sm col-md-3 text-center "
                      aria-label=".form-select-sm example"
                      onChange={onChange}
                    >
                      {cmbCedula &&
                        cmbCedula.map((item, index) => (
                          <option key={index} value={item.value}>
                            {item.value}
                          </option>
                        ))}
                    </select>
                    <input
                      ref={txtRif}
                      autoComplete="off"
                      disabled={!habilitadoCli}
                      maxLength={9}
                      type="text"
                      className="form-control fs-6"
                      name="cedula"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      onKeyUp={validarCliente}
                      onBlur={validarCliente}
                      onChange={onChange}
                    />
                    <button
                      disabled={!habilitadoCli}
                      type="button"
                      onClick={() => setCatalogoCliente(true)}
                      className="btn btn-success"
                      style={{
                        visibility: visible === 0 ? "visible" : "hidden",
                      }}
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                  <div className="input-group input-group-sm mb-2 col-md-7">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      NOMBRE:{" "}
                    </label>
                    <input
                      disabled
                      autoComplete="off"
                      type="text"
                      className="form-control fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={nomCliente}
                    />
                  </div>
                  <div className="input-group input-group-sm mb-2 col-md-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      DIRECCION:{" "}
                    </label>
                    <input
                      disabled
                      autoComplete="off"
                      type="text"
                      className="form-control fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={dirCliente}
                    />
                  </div>
                </div>
              </div>

              <div
                className="colfull1070 colfull40p mx-auto mb-1 row py-1"
                style={{ fontSizeAdjust: "0.6" }}
              >
                <div className="col-md-12 mx-auto row border-azul rounded py-2">
                  <span className="fw-bold mb-1">Datos del Vendedor</span>
                  <div className="input-group input-group-sm col-pd-240 px-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                      style={{ height: "85%" }}
                    >
                      CEDULA/RIF:{" "}
                    </label>
                    <input
                      disabled
                      autoComplete="off"
                      type="text"
                      className="form-control fs-6"
                      style={{ height: "85%" }}
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={cedRif}
                    />
                  </div>
                  <div className="input-group input-group-sm col-md-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                      style={{ height: "85%" }}
                    >
                      NOMBRE:{" "}
                    </label>
                    <input
                      disabled
                      autoComplete="off"
                      type="text"
                      style={{ height: "85%" }}
                      className="form-control fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={nomVendedor}
                    />
                  </div>
                </div>
                <div className="col-md-6"></div>
              </div>
              <div className="colfull60p row m-0">
                <div
                  className="col-md-12 border-azul rounded p-2 shadow"
                  style={{ fontSizeAdjust: "0.6" }}
                >
                  <div className="input-group input-group-sm mb-2 col-md-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      CONCEPTO:
                    </label>
                    <textarea
                      className="form-control uppercase fs-6"
                      ref={txtConcepto}
                      disabled={!habilitado}
                      aria-label="With textarea"
                      style={{ minHeight: 50 }}
                      defaultValue={""}
                    />
                  </div>
                  <div className="input-group input-group-sm mb-2 col-md-5 ml-auto">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      MONTO TOTAL {moneda.descripcion + " " + moneda.simbolo}:
                    </label>
                    <input
                      autoComplete="off"
                      type="text"
                      ref={txtTotalDivisa}
                      disabled={!habilitado}
                      onFocus={seleccionarCampo}
                      onKeyUp={validarCantidad}
                      onBlur={validarCantidad}
                      className="form-control text-end fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue="0,00"
                    />
                  </div>
                  <div className="input-group input-group-sm mb-2 col-md-5 ml-auto">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      MONTO TOTAL Bs: {/* {moneda.simbolo}: */}
                    </label>
                    <input
                      autoComplete="off"
                      type="text"
                      ref={txtMontoTotal}
                      disabled
                      /*                       disabled={!habilitado}
                      onFocus={seleccionarCampo}
                      onKeyUp={validarCantidad}
                      onBlur={validarCantidad} */
                      className="form-control text-end fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue="0,00"
                    />
                  </div>
                </div>
              </div>
              <div className="colfull40p row m-0">
                <div className="col-md-12"></div>
              </div>
              <div className="col-md-12 pt-2 pb-2 mt-auto">
                {visibleBtn === "visible" ? (
                  <div className="col-pd-botones">
                    <div className="col-md-12 row m-0">
                      <button
                        disabled={!habilitadoBot}
                        ref={btnIncluir}
                        onClick={onBotones(1)}
                        className="btn btn-sm col ml-1 mb-1 btn-primary rounded-pill"
                        title="Incluir Nota de Entrega"
                      >
                        <i className="fas fa-plus"> Incluir </i>{" "}
                      </button>
                      <button
                        disabled={!habilitadoBot}
                        ref={btnConsultar}
                        onClick={onBotones(4)}
                        className="btn btn-sm col ml-1 mb-1 btn-info rounded-pill"
                        title="Consultar Nota de Entrega"
                      >
                        <i className="fas fa-eye"> Consultar</i>{" "}
                      </button>
                      <button
                        disabled={!habilitadoBot}
                        ref={btnEditar}
                        onClick={onBotones(2)}
                        className="btn btn-sm col ml-1 mb-1 btn-warning rounded-pill"
                        title="Modificar Nota de Entrega"
                      >
                        <i className="fa fa-edit"> Modificar</i>{" "}
                      </button>
                      <button
                        disabled={!habilitadoBot}
                        ref={btnEliminar}
                        onClick={onBotones(3)}
                        className="btn btn-sm col ml-1 mb-1 btn-danger rounded-pill"
                        title="Eliminar Nota de Entrega"
                      >
                        <i className="fa fa-trash"> Eliminar</i>{" "}
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="col-pd-360 row m-0 ml-auto">
                    {operacion === 4 ? (
                      <button
                        onClick={imprimirNotaDebito}
                        disabled={operacion === 4 ? false : true}
                        className="btn btn-sm col ml-1 btn-primary rounded-pill"
                        title="Imprimir Nota de Entrega"
                      >
                        <i className="fa fa-print"> Imprimir</i>
                      </button>
                    ) : (
                      ""
                    )}

                    <button
                      ref={btnAcepta}
                      disabled={operacion === 4 ? true : habilitadoBot}
                      onClick={onBotones(5)}
                      className="btn btn-sm col ml-1 rounded-pill btn-success"
                    >
                      <i className="fas fa-check-circle"> Aceptar</i>
                    </button>
                    <button
                      ref={btnCancela}
                      disabled={habilitadoBot}
                      onClick={onBotones(6)}
                      className="btn btn-danger col ml-1 btn-sm rounded-pill"
                    >
                      <i className="fas fa-window-close"> Cancelar</i>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <CatalogoCliente
        show={catalogoCliente}
        nomid="cliente"
        onHideCancelar={() => setCatalogoCliente(false)}
        onHideAceptaCatalogo={onCatalogoCliente}
      />
      <CatalogoNotaEntrega
        show={catalogoNota}
        tipo={"NC"}
        tip="FA"
        nomid="notaentrega"
        onHideCancelar={() => setCatalogoNota(false)}
        onHideAceptaCatalogo={onCatalogoNotaEntrega}
        condicion="true"
      />

      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>
      <Mensaje mensaje={mensaje} onHide={handleCloseMensaje} />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
};
export default TablaNotaCredito;



// WEBPACK FOOTER //
// ./src/components/ventas/tablaNotaCredito.js